import { callAppAPI, gererRedirectSecuriteFor401 } from "./AppApiClient";
import { DictionnaireApi } from "./DictionnaireApi";
import { InfoPersoUpdate } from "src/pages/infoperso/infoperso/useValidationSchemaInfoPersoUpdate";
import { CheckMailCode } from "src/pages/finalisation/etapes/verificationMail/codeMailCheck/useValidationSchemaMailCode";
import { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { UpdatePassword } from "src/pages/infoperso/connexion/module/password/useValidationSchemaPasswordUpdate";
import { HistoriqueConnexion } from "src/domain/HistoriqueConnexion";
import { Account, ActiveService, PointMenuDto, User } from "src/domain/User";
import { Favori } from "src/domain/Favori";
import { AxiosError } from "axios";

export const fetchUser = async () => {
  return callAppAPI<User>({
    method: "GET",
    url: DictionnaireApi.user.getUrl(),
  })
    .then(result => {
      return result;
    })
    .catch(err => {
      console.log("user non connecté. Error : " + err);
      return null;
    });
};

export const fetchServices = async (uuidEmployeur?: string, noTiers?: string) => {
  return callAppAPI<Account>({
    method: "GET",
    url: DictionnaireApi.services.getUrl(),
    params: { uuidEmployeur, noTiers }
  })
      .then(result => {
        return result;
      })
      .catch(err => {
        console.log("user non connecté. Error : " + err);
        return null;
      });
};

export const fetchMenuGauche = async (uuidEmployeur?: string, noTiers?: string) => {
  return callAppAPI<PointMenuDto[]>({
    method: "GET",
    url: DictionnaireApi.menuGauche.getUrl(),
    params: { uuidEmployeur, noTiers }
  })
      .then(result => {
        return result;
      })
      .catch(err => {
        console.log("user non connecté. Error : " + err);
        return null;
      });
};

export const fetchBai = async () => {
  return callAppAPI<ActiveService>({
    method: "GET",
    url: DictionnaireApi.bai.getUrl(),
  })
      .then(result => {
        return result;
      })
      .catch(err => {
        console.log("user non connecté. Error : " + err);
        return null;
      });
};

export const fetchCybersafe = async () => {
  return callAppAPI<ActiveService>({
    method: "GET",
    url: DictionnaireApi.cybersafe.getUrl(),
  })
    .then(result => {
      return result;
    })
    .catch(err => {
      console.log("user non connecté. Error : " + err);
      return null;
    });
};

export const fetchFavoris = async () => {
  return callAppAPI<string[]>({
    method: "GET",
    url: DictionnaireApi.favoris.getUrl(),
  })
    .then(result => {
      return result;
    })
    .catch(err => {
      console.log("user non connecté. Error : " + err);
      return null;
    });
};


export const ajouterFavori = async (favori: Favori) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.ajouterFavori.getUrl(),
    data: favori,
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const supprimerFavori = async (favori: Favori) => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.supprimerFavori.getUrl(),
    data: favori,
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const deleteAccount = async () => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.account.getUrl(),
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const fetchHistoriqueConnexion = async (): Promise<HistoriqueConnexion> => {
  return callAppAPI<HistoriqueConnexion>({
    method: "GET",
    url: DictionnaireApi.historiqueConnexion.getUrl(),
  })
    .then(result => {
      return result._loginHistory;
    });
};

export const validateCGU = async () => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.validateCGU.getUrl(),
    data: {},
  });
};

export const setPersonalInfoUpdate = async (values: InfoPersoUpdate) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.setPersonalInfoUpdate.getUrl(),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const setEmail = async (values: CheckMailCode, locale: string) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.setEmail.getUrl(),
    data: { ...values, locale },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const setMobile = async (values: CheckTelephoneCode) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.mobile.getUrl(),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const deleteMobile = async () => {
  return callAppAPI<void>({
    method: "DELETE",
    url: DictionnaireApi.mobile.getUrl(),
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

export const setPassword = async (values: UpdatePassword) => {
  return callAppAPI<void>({
    method: "POST",
    url: DictionnaireApi.setPassword.getUrl(),
    data: { ...values },
  }).catch((error : AxiosError) => {
    gererRedirectSecuriteFor401(error);
  });
};

